import { render, staticRenderFns } from "./RecordDetail.vue?vue&type=template&id=146d134f&scoped=true"
import script from "./RecordDetail.vue?vue&type=script&lang=js"
export * from "./RecordDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordDetail.vue?vue&type=style&index=0&id=146d134f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d134f",
  null
  
)

export default component.exports